import { useQuery } from "@tanstack/react-query";

import { getMe } from "../dashboardApi";
import type { User, UserRole } from "../../types/dashboard";

const ROLE_RANK: Record<UserRole, number> = {
  viewer: 0,
  editor: 1,
  admin: 2,
  owner: 3,
};

export function useAuthMe() {
  return useQuery<User>({
    queryKey: ["auth", "me"],
    queryFn: getMe,
    staleTime: 60_000,
    retry: false,
  });
}

export function hasMinRole(user: User | undefined, min: UserRole): boolean {
  if (!user) return false;
  return ROLE_RANK[user.role] >= ROLE_RANK[min];
}
